import producer from 'immer';
import {
  changeEnabledButton,
  changeBottomButtonPayload,
  changeIsSubmitting,
} from './handlers';
import { steps } from '../../Base/containers/AnnouncementSteps/steps';
import { CHANGE_ENABLED_BUTTON, CHANGE_BOTTOM_BUTTON_PAYLOAD } from './types';
import { UPDATE_PHOTOS } from '../PhotosManager/types';
import { UPLOAD_VIDEO_LINK } from '../Video/types';

export const initialState = {
  isSubmitting: false,
  enabledButton: true,
  allSteps: steps,
  bottomButtonPayload: {},
};

export const announcementStepsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CHANGE_ENABLED_BUTTON:
      return changeEnabledButton(state, action);
    case CHANGE_BOTTOM_BUTTON_PAYLOAD:
      return changeBottomButtonPayload(state, action);
    case UPDATE_PHOTOS:
    case UPLOAD_VIDEO_LINK:
      return changeIsSubmitting(state, action);
    default:
      return state;
  }
};

export default producer(announcementStepsReducer);
